import React from 'react'
import {Icon} from '@chakra-ui/react'
const CloseLargerIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" cursor="pointer" fill="transparent" {...props}>
            <g clipPath="url(#clip0_3593_1551)">
                <circle cx="20" cy="19.9999" r="20" fill="white" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.8502 20.0017L28.487 12.3649C28.7212 12.1307 28.7212 11.7506 28.487 11.5164C28.2528 11.2822 27.8726 11.2822 27.6385 11.5164L20.0017 19.1532L12.3632 11.5147C12.1291 11.2805 11.7489 11.2805 11.5147 11.5147C11.2805 11.7489 11.2805 12.129 11.5147 12.3632L19.1532 20.0017L11.5164 27.6384C11.2822 27.8726 11.2822 28.2528 11.5164 28.487C11.7506 28.7212 12.1307 28.7212 12.3649 28.487L20.0017 20.8502L27.6368 28.4853C27.8709 28.7195 28.2511 28.7195 28.4853 28.4853C28.7195 28.2511 28.7195 27.8709 28.4853 27.6367L20.8502 20.0017Z"
                    fill="#D11B59"
                />
            </g>
            <defs>
                <clipPath id="clip0_3593_1551">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default CloseLargerIcon
